import { FC, useState } from 'react';
import { Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface IProfessionTypeCardProps {
  icon: FC<{ color?: string; circleColor?: string }>;
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

export const ProfessionTypeCard: FC<IProfessionTypeCardProps> = ({
  icon: Icon,
  label,
  isSelected,
  onClick,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const getBackgroundColor = () => {
    if (isSelected) return colors.primary[50];
    return colors.neutral[50];
  };

  const getBorder = () => {
    if (isSelected) return `2px solid ${colors.secondary[500]}`;
    return `2px solid ${colors.neutral[50]}`;
  };

  const getBoxShadow = () => {
    if (!isSelected && isHovered) {
      return '0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)';
    }
    return 'none';
  };

  return (
    <Column
      data-testid="profession-type-card"
      data-cy="profession-type-card"
      align="center"
      justify="center"
      gap={2}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        width: 96,
        height: 132,
        borderRadius: 8,
        backgroundColor: getBackgroundColor(),
        border: getBorder(),
        boxShadow: getBoxShadow(),
        transform: !isSelected && isHovered ? 'scale(1.08)' : 'scale(1)',
        cursor: 'pointer',
        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
      }}
    >
      <Icon
        color={isSelected ? colors.primary[500] : undefined}
        circleColor={isSelected ? '#D0EFF2' : undefined}
      />
      <Typography
        as="span"
        size="body_small"
        color={isSelected ? colors.neutral[600] : colors.neutral[500]}
        textAlign="center"
        style={{ fontFamily: 'Nunito', lineHeight: 1.2, width: 68 }}
      >
        {label}
      </Typography>
    </Column>
  );
};
